import { OverlayTrigger, Tooltip } from "react-bootstrap";
import IconView from "../../assets/images/view.png";

const text = {
    "bell.png": "Gửi thông báo",
    "schedule-hidden.png": "Hiện sự kiện",
    "schedule-show.svg.png": "Ẩn sự kiện",
};

export default function ActionEditDelete(props) {
    const {
        onclickEdit,
        onclickDelete,
        onclickView,
        tooltipText,
        hideEdit,
        hideDelete,
        hideView,
        onclickPreviewView,
        subIcon,
        onclickSubIcon,
        onclickBell,
        isShowBell,
    } = props;
    return (
        <>
            {/* <OverlayTrigger
                overlay={<Tooltip id="products-delete-tooltip">Preview {tooltipText}</Tooltip>}
            >
                <span
                    className="btn btn-icon btn-light btn-hover-danger btn-sm"
                >
                    <span onClick={onclickPreviewView} className="svg-icon svg-icon-md svg-icon-success">

                        <SVG src={toAbsoluteUrl("/media/svg/icons/Media/Airplay-video.svg")} />
                    </span>
                </span>
            </OverlayTrigger> */}
            {!hideView && (
                <OverlayTrigger
                    overlay={
                        <Tooltip id="products-view-tooltip">
                            Xem chi tiết {tooltipText}
                        </Tooltip>
                    }
                >
                    <span
                        className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
                        onClick={onclickView}
                    >
                        <span className="svg-icon svg-icon-md svg-icon-primary">
                            <img
                                src={IconView}
                                alt=""
                                style={{width: "19.5px", height: "19.5px"}}
                            />
                        </span>
                    </span>
                </OverlayTrigger>
            )}

            {!hideEdit && (
                <OverlayTrigger
                    overlay={
                        <Tooltip id="products-edit-tooltip">
                            Sửa {tooltipText}
                        </Tooltip>
                    }
                >
                    <span
                        className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
                        onClick={onclickEdit}
                    >
                        <span className="svg-icon svg-icon-md svg-icon-primary">
                            {/*  <SVG
                            src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
                        /> */}
                            <img
                                src={"/media/svg/icons/Communication/Write.svg"}
                                alt=""
                                style={{width: "19.5px", height: "19.5px"}}
                            />
                        </span>
                    </span>
                </OverlayTrigger>
            )}

            <> </>
            {!hideDelete && (
                <OverlayTrigger
                    overlay={
                        <Tooltip id="products-delete-tooltip">
                            Xóa {tooltipText}
                        </Tooltip>
                    }
                >
                    <span className="btn btn-icon btn-light btn-hover-danger btn-sm">
                        <span
                            onClick={onclickDelete}
                            className="svg-icon svg-icon-md svg-icon-danger"
                        >
                            {/* <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} /> */}
                            <img
                                src={"/media/svg/icons/General/Trash.svg"}
                                alt=""
                                style={{width: "19.5px", height: "19.5px"}}
                            />
                        </span>
                    </span>
                </OverlayTrigger>
            )}
            {!!isShowBell && (
                <OverlayTrigger
                    overlay={
                        <Tooltip id="products-view-tooltip">
                            {text["bell.png"]} {tooltipText}
                        </Tooltip>
                    }
                >
                    <span
                        className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
                        onClick={onclickBell}
                    >
                        <img
                            src={`/media/svg/schedule/bell.png`}
                            alt=""
                            style={{width: "19.5px", height: "19.5px"}}
                        />
                    </span>
                </OverlayTrigger>
            )}
            {!!subIcon && (
                <OverlayTrigger
                    overlay={
                        <Tooltip id="products-view-tooltip">
                            {text[subIcon]} {tooltipText}
                        </Tooltip>
                    }
                >
                    <span
                        className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
                        onClick={onclickSubIcon}
                    >
                        <img
                            src={`/media/svg/schedule/${subIcon}`}
                            alt=""
                            style={{width: "19.5px", height: "19.5px"}}
                        />
                    </span>
                </OverlayTrigger>
            )}
        </>
    );
}
